export default "3b6b78da8e9809d5.svg"